import FitnessWorkspace from './FitnessWorkspace';

export default FitnessWorkspace;
